import { Logger } from '@vp/ubik-logging'
import { applyServiceHeaders } from 'server/utils/applyServiceHeaders'
import { createApiClient } from 'shared/services/ApiClient'
import { ApiClient } from 'shared/services/ApiClient/interface'

export type LoggerParameter = (() => Gallery.Logger.ILogger) | Gallery.Logger.ILogger

export class AbstractService {
  api: ApiClient

  config: Gallery.Config.IServiceConfig

  loggerOrProvider: LoggerParameter

  constructor(serviceConfig: Gallery.Config.IServiceConfig, logger: LoggerParameter) {
    this.api = createApiClient(
      {
        ...applyServiceHeaders({
          ...serviceConfig,
        }),
      },
      this.constructor.name,
    )

    this.config = serviceConfig || {}
    this.loggerOrProvider = logger
  }

  get logger(): Logger {
    return typeof this.loggerOrProvider === 'function' ? this.loggerOrProvider() : this.loggerOrProvider
  }
}
